module.exports = [
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Property to bind a model to the input.\nIf the user changes the input value, the model updates, too.\nIf the user presses enter with an valid input,\na new tag is created with the value of this model.\nAfter creating the new tag, the model is cleared.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 5,
                  "column": 50,
                  "offset": 247
                },
                "indent": [
                  1,
                  1,
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 5,
              "column": 50,
              "offset": 247
            },
            "indent": [
              1,
              1,
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 5,
          "column": 50,
          "offset": 247
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Property to bind a model to the input.\nIf the user changes the input value, the model updates, too.\nIf the user presses enter with an valid input,\na new tag is created with the value of this model.\nAfter creating the new tag, the model is cleared.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "required",
        "description": null,
        "lineNumber": 7
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 8,
        "type": {
          "type": "NameExpression",
          "name": "String"
        }
      },
      {
        "title": "model",
        "description": null,
        "lineNumber": 9
      },
      {
        "title": "default",
        "description": "''",
        "lineNumber": 10
      }
    ],
    "loc": {
      "start": {
        "line": 40,
        "column": 2
      },
      "end": {
        "line": 51,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 52,
          "column": 2
        },
        "end": {
          "line": 56,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "String"
    },
    "name": "value",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "value",
        "scope": "static"
      }
    ],
    "namespace": ".value"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Pass an array containing objects like in the example below.\nThe properties 'style' and 'class' are optional. Of course it is possible to add custom\nproperties to a tag object. vue-tags-input won't change the key and value.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 75,
                  "offset": 222
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 75,
              "offset": 222
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 75,
          "offset": 222
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Pass an array containing objects like in the example below.\nThe properties 'style' and 'class' are optional. Of course it is possible to add custom\nproperties to a tag object. vue-tags-input won't change the key and value.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "sync",
        "description": null,
        "lineNumber": 6
      },
      {
        "title": "default",
        "description": "[]",
        "lineNumber": 7
      },
      {
        "title": "example",
        "description": "{\n&emsp;text: 'My tag value', &#47;* The visible text on display *&#47;\n&emsp;style: 'background-color: #ccc', &#47;* Adding inline styles is possible *&#47;\n&emsp;classes: 'custom-class another', &#47;* The value will be added as css classes *&#47;\n}",
        "lineNumber": 8
      }
    ],
    "loc": {
      "start": {
        "line": 57,
        "column": 2
      },
      "end": {
        "line": 71,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 72,
          "column": 2
        },
        "end": {
          "line": 76,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "{\n&emsp;text: 'My tag value', &#47;* The visible text on display *&#47;\n&emsp;style: 'background-color: #ccc', &#47;* Adding inline styles is possible *&#47;\n&emsp;classes: 'custom-class another', &#47;* The value will be added as css classes *&#47;\n}"
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "tags",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "tags",
        "scope": "static"
      }
    ],
    "namespace": ".tags"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Expects an array containing objects inside. The objects\ncan have the same properties as a tag object.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 46,
                  "offset": 101
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 46,
              "offset": 101
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 46,
          "offset": 101
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Expects an array containing objects inside. The objects\ncan have the same properties as a tag object.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[]",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 77,
        "column": 2
      },
      "end": {
        "line": 83,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 84,
          "column": 2
        },
        "end": {
          "line": 88,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "autocompleteItems",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteItems",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteItems"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines whether a tag is editable after creation or not.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 57,
                  "offset": 56
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 57,
              "offset": 56
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 57,
          "offset": 56
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines whether a tag is editable after creation or not.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 89,
        "column": 2
      },
      "end": {
        "line": 94,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 95,
          "column": 2
        },
        "end": {
          "line": 98,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "allowEditTags",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "allowEditTags",
        "scope": "static"
      }
    ],
    "namespace": ".allowEditTags"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines if duplicate autocomplete items are filtered out from the view or not.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 79,
                  "offset": 78
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 79,
              "offset": 78
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 79,
          "offset": 78
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines if duplicate autocomplete items are filtered out from the view or not.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 99,
        "column": 2
      },
      "end": {
        "line": 104,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 105,
          "column": 2
        },
        "end": {
          "line": 108,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "autocompleteFilterDuplicates",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteFilterDuplicates",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteFilterDuplicates"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the user can add tags only via the autocomplete layer.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 69,
                  "offset": 68
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 69,
              "offset": 68
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 69,
          "offset": 68
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the user can add tags only via the autocomplete layer.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 109,
        "column": 2
      },
      "end": {
        "line": 114,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 115,
          "column": 2
        },
        "end": {
          "line": 118,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "addOnlyFromAutocomplete",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addOnlyFromAutocomplete",
        "scope": "static"
      }
    ],
    "namespace": ".addOnlyFromAutocomplete"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The minimum character length which is required\nuntil the autocomplete layer is shown. If set to 0,\nthen it'll be shown on focus.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 30,
                  "offset": 128
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 30,
              "offset": 128
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 30,
          "offset": 128
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The minimum character length which is required\nuntil the autocomplete layer is shown. If set to 0,\nthen it'll be shown on focus.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Number"
        }
      },
      {
        "title": "default",
        "description": "1",
        "lineNumber": 6
      }
    ],
    "loc": {
      "start": {
        "line": 119,
        "column": 2
      },
      "end": {
        "line": 126,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 127,
          "column": 2
        },
        "end": {
          "line": 130,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Number"
    },
    "name": "autocompleteMinLength",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteMinLength",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteMinLength"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the autocomplete layer is always shown, regardless if\nan input or an autocomplete items exists.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 42,
                  "offset": 109
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 42,
              "offset": 109
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 42,
          "offset": 109
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the autocomplete layer is always shown, regardless if\nan input or an autocomplete items exists.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 131,
        "column": 2
      },
      "end": {
        "line": 137,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 138,
          "column": 2
        },
        "end": {
          "line": 141,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "autocompleteAlwaysOpen",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "autocompleteAlwaysOpen",
        "scope": "static"
      }
    ],
    "namespace": ".autocompleteAlwaysOpen"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Property to disable vue-tags-input.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 36,
                  "offset": 35
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 36,
              "offset": 35
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 36,
          "offset": 35
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Property to disable vue-tags-input.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "false",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 142,
        "column": 2
      },
      "end": {
        "line": 147,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 148,
          "column": 2
        },
        "end": {
          "line": 151,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "disabled",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "disabled",
        "scope": "static"
      }
    ],
    "namespace": ".disabled"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The placeholder text which is shown in the input, when it's empty.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 67,
                  "offset": 66
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 67,
              "offset": 66
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 67,
          "offset": 66
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The placeholder text which is shown in the input, when it's empty.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "String"
        }
      },
      {
        "title": "default",
        "description": "Add Tag",
        "lineNumber": 4
      }
    ],
    "loc": {
      "start": {
        "line": 152,
        "column": 2
      },
      "end": {
        "line": 157,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 158,
          "column": 2
        },
        "end": {
          "line": 161,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "String"
    },
    "name": "placeholder",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "placeholder",
        "scope": "static"
      }
    ],
    "namespace": ".placeholder"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Custom trigger key codes can be registrated. If the user presses one of these,\na tag will be generated out of the input value. Can be either a numeric keyCode or the key\nas a string.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 13,
                  "offset": 182
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 13,
              "offset": 182
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 13,
          "offset": 182
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Custom trigger key codes can be registrated. If the user presses one of these,\na tag will be generated out of the input value. Can be either a numeric keyCode or the key\nas a string.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[13]",
        "lineNumber": 6
      },
      {
        "title": "example",
        "description": "add-on-key=\"[13, ':', ';']\"",
        "lineNumber": 7
      }
    ],
    "loc": {
      "start": {
        "line": 162,
        "column": 2
      },
      "end": {
        "line": 170,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 171,
          "column": 2
        },
        "end": {
          "line": 175,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "add-on-key=\"[13, ':', ';']\""
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "addOnKey",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addOnKey",
        "scope": "static"
      }
    ],
    "namespace": ".addOnKey"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Custom trigger key codes can be registrated. If the user edits a tag\nand presses one of these, the edited tag will be saved.\nCan be either a numeric keyCode or the key as a string.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 3,
                  "column": 56,
                  "offset": 180
                },
                "indent": [
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 3,
              "column": 56,
              "offset": 180
            },
            "indent": [
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 3,
          "column": 56,
          "offset": 180
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Custom trigger key codes can be registrated. If the user edits a tag\nand presses one of these, the edited tag will be saved.\nCan be either a numeric keyCode or the key as a string.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[13]",
        "lineNumber": 6
      },
      {
        "title": "example",
        "description": "save-on-key=\"[13, ':', ';']\"",
        "lineNumber": 7
      }
    ],
    "loc": {
      "start": {
        "line": 176,
        "column": 2
      },
      "end": {
        "line": 184,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 185,
          "column": 2
        },
        "end": {
          "line": 189,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "save-on-key=\"[13, ':', ';']\""
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "saveOnKey",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "saveOnKey",
        "scope": "static"
      }
    ],
    "namespace": ".saveOnKey"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The maximum amount the tags array is allowed to hold.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 54,
                  "offset": 53
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 54,
              "offset": 53
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 54,
          "offset": 53
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The maximum amount the tags array is allowed to hold.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Number"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 190,
        "column": 2
      },
      "end": {
        "line": 194,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 195,
          "column": 2
        },
        "end": {
          "line": 197,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Number"
    },
    "name": "maxTags",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "maxTags",
        "scope": "static"
      }
    ],
    "namespace": ".maxTags"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "The maximum amount of characters the input is allowed to hold.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 63,
                  "offset": 62
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 63,
              "offset": 62
            },
            "indent": []
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 1,
          "column": 63,
          "offset": 62
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "The maximum amount of characters the input is allowed to hold.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 2,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "Number"
        }
      }
    ],
    "loc": {
      "start": {
        "line": 198,
        "column": 2
      },
      "end": {
        "line": 202,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 203,
          "column": 2
        },
        "end": {
          "line": 205,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Number"
    },
    "name": "maxlength",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "maxlength",
        "scope": "static"
      }
    ],
    "namespace": ".maxlength"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Pass an array containing objects like in the example below.\nThe property 'classes' will be added as css classes, if the property 'rule' matches the text\nof a tag, an autocomplete item or the input. The property 'rule' can be type of\nRegExp or function. If the property 'disableAdd' is 'true', the item can't be added\nto the tags array, if the appropriated rule matches.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 5,
                  "column": 53,
                  "offset": 369
                },
                "indent": [
                  1,
                  1,
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 5,
              "column": 53,
              "offset": 369
            },
            "indent": [
              1,
              1,
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 5,
          "column": 53,
          "offset": 369
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Pass an array containing objects like in the example below.\nThe property 'classes' will be added as css classes, if the property 'rule' matches the text\nof a tag, an autocomplete item or the input. The property 'rule' can be type of\nRegExp or function. If the property 'disableAdd' is 'true', the item can't be added\nto the tags array, if the appropriated rule matches.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 7,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[]",
        "lineNumber": 8
      },
      {
        "title": "example",
        "description": "{\n&ensp;classes: 'class', &#47;* css class *&#47;\n&ensp;rule: /^([^0-9]*)$/, &#47;* RegExp *&#47;\n}, {\n&ensp;classes: 'no-braces', &#47;* css class *&#47;\n&ensp;rule(text) { &#47;* function with text as param *&#47;\n&ensp;&ensp;return text.indexOf('{') !== -1 || text.indexOf('}') !== -1;\n&ensp;},\n&ensp;disableAdd: true, &#47;* if the rule matches, the item cannot be added *&#47;,\n},",
        "lineNumber": 9
      }
    ],
    "loc": {
      "start": {
        "line": 206,
        "column": 2
      },
      "end": {
        "line": 226,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 227,
          "column": 2
        },
        "end": {
          "line": 257,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "{\n&ensp;classes: 'class', &#47;* css class *&#47;\n&ensp;rule: /^([^0-9]*)$/, &#47;* RegExp *&#47;\n}, {\n&ensp;classes: 'no-braces', &#47;* css class *&#47;\n&ensp;rule(text) { &#47;* function with text as param *&#47;\n&ensp;&ensp;return text.indexOf('{') !== -1 || text.indexOf('}') !== -1;\n&ensp;},\n&ensp;disableAdd: true, &#47;* if the rule matches, the item cannot be added *&#47;,\n},"
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "validation",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "validation",
        "scope": "static"
      }
    ],
    "namespace": ".validation"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines the characters which splits a text into different pieces,\nto generate tags out of this pieces.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 37,
                  "offset": 102
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 37,
              "offset": 102
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 37,
          "offset": 102
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines the characters which splits a text into different pieces,\nto generate tags out of this pieces.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "default",
        "description": "[';']",
        "lineNumber": 5
      },
      {
        "title": "example",
        "description": "separators: [';', ',']\ninput: some; user input, has random; commas, an,d semicolons\nwill split into: some - user input - has random - commas - an - d semicolons",
        "lineNumber": 6
      }
    ],
    "loc": {
      "start": {
        "line": 258,
        "column": 2
      },
      "end": {
        "line": 268,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 269,
          "column": 2
        },
        "end": {
          "line": 279,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "separators: [';', ',']\ninput: some; user input, has random; commas, an,d semicolons\nwill split into: some - user input - has random - commas - an - d semicolons"
      }
    ],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Array"
    },
    "name": "separators",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "separators",
        "scope": "static"
      }
    ],
    "namespace": ".separators"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the user can't add or save a tag,\nif another exists, with the same text value.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 45,
                  "offset": 92
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 45,
              "offset": 92
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 45,
          "offset": 92
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the user can't add or save a tag,\nif another exists, with the same text value.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 280,
        "column": 2
      },
      "end": {
        "line": 286,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 287,
          "column": 2
        },
        "end": {
          "line": 290,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "avoidAddingDuplicates",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "avoidAddingDuplicates",
        "scope": "static"
      }
    ],
    "namespace": ".avoidAddingDuplicates"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If the input holds a value and loses the focus,\na tag will be generated out of this value, if possible.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 56,
                  "offset": 103
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 56,
              "offset": 103
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 56,
          "offset": 103
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If the input holds a value and loses the focus,\na tag will be generated out of this value, if possible.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 291,
        "column": 2
      },
      "end": {
        "line": 297,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 298,
          "column": 2
        },
        "end": {
          "line": 301,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "addOnBlur",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addOnBlur",
        "scope": "static"
      }
    ],
    "namespace": ".addOnBlur"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Custom function to detect duplicates. If the function returns 'true',\nthe tag will be marked as duplicate.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 37,
                  "offset": 106
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 37,
              "offset": 106
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 37,
          "offset": 106
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Custom function to detect duplicates. If the function returns 'true',\nthe tag will be marked as duplicate.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Function"
        }
      },
      {
        "title": "param",
        "description": "The Array of tags minus the one which is edited/created.",
        "lineNumber": 5,
        "type": {
          "type": "NameExpression",
          "name": "Array"
        },
        "name": "tagsarray"
      },
      {
        "title": "param",
        "description": "The tag which is edited or should be added to the tags array.",
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "Object"
        },
        "name": "tag"
      },
      {
        "title": "example",
        "description": "// The duplicate function to recreate the default behaviour, would look like this:\nisDuplicate(tags, tag) {\n&ensp;return tags.map(t => t.text).indexOf(tag.text) !== -1;\n}",
        "lineNumber": 7
      }
    ],
    "loc": {
      "start": {
        "line": 302,
        "column": 2
      },
      "end": {
        "line": 314,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 315,
          "column": 2
        },
        "end": {
          "line": 318,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [
      {
        "description": "// The duplicate function to recreate the default behaviour, would look like this:\nisDuplicate(tags, tag) {\n&ensp;return tags.map(t => t.text).indexOf(tag.text) !== -1;\n}"
      }
    ],
    "params": [
      {
        "title": "param",
        "name": "tagsarray",
        "lineNumber": 5,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The Array of tags minus the one which is edited/created.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 57,
                      "offset": 56
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 57,
                  "offset": 56
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 57,
              "offset": 56
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Array"
        }
      },
      {
        "title": "param",
        "name": "tag",
        "lineNumber": 6,
        "description": {
          "type": "root",
          "children": [
            {
              "type": "paragraph",
              "children": [
                {
                  "type": "text",
                  "value": "The tag which is edited or should be added to the tags array.",
                  "position": {
                    "start": {
                      "line": 1,
                      "column": 1,
                      "offset": 0
                    },
                    "end": {
                      "line": 1,
                      "column": 62,
                      "offset": 61
                    },
                    "indent": []
                  }
                }
              ],
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 1,
                  "column": 62,
                  "offset": 61
                },
                "indent": []
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 1,
              "column": 62,
              "offset": 61
            }
          }
        },
        "type": {
          "type": "NameExpression",
          "name": "Object"
        }
      }
    ],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Function"
    },
    "name": "isDuplicate",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "isDuplicate",
        "scope": "static"
      }
    ],
    "namespace": ".isDuplicate"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "If it's true, the user can paste into the input element and\nvue-tags-input will create tags out of the incoming text.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 2,
                  "column": 58,
                  "offset": 117
                },
                "indent": [
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 2,
              "column": 58,
              "offset": 117
            },
            "indent": [
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 2,
          "column": 58,
          "offset": 117
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "If it's true, the user can paste into the input element and\nvue-tags-input will create tags out of the incoming text.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 3,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 4,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 5
      }
    ],
    "loc": {
      "start": {
        "line": 319,
        "column": 2
      },
      "end": {
        "line": 325,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 326,
          "column": 2
        },
        "end": {
          "line": 329,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "addFromPaste",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "addFromPaste",
        "scope": "static"
      }
    ],
    "namespace": ".addFromPaste"
  },
  {
    "description": {
      "type": "root",
      "children": [
        {
          "type": "paragraph",
          "children": [
            {
              "type": "text",
              "value": "Defines if it's possible to delete tags by pressing backspace.\nIf so and the user wants to delete a tag,\nthe tag gets the css class 'deletion-mark' for 1 second.\nIf the user presses backspace again in that time period,\nthe tag is removed from the tags array and the view.",
              "position": {
                "start": {
                  "line": 1,
                  "column": 1,
                  "offset": 0
                },
                "end": {
                  "line": 5,
                  "column": 53,
                  "offset": 271
                },
                "indent": [
                  1,
                  1,
                  1,
                  1
                ]
              }
            }
          ],
          "position": {
            "start": {
              "line": 1,
              "column": 1,
              "offset": 0
            },
            "end": {
              "line": 5,
              "column": 53,
              "offset": 271
            },
            "indent": [
              1,
              1,
              1,
              1
            ]
          }
        }
      ],
      "position": {
        "start": {
          "line": 1,
          "column": 1,
          "offset": 0
        },
        "end": {
          "line": 5,
          "column": 53,
          "offset": 271
        }
      }
    },
    "tags": [
      {
        "title": "description",
        "description": "Defines if it's possible to delete tags by pressing backspace.\nIf so and the user wants to delete a tag,\nthe tag gets the css class 'deletion-mark' for 1 second.\nIf the user presses backspace again in that time period,\nthe tag is removed from the tags array and the view.",
        "lineNumber": 1
      },
      {
        "title": "property",
        "description": null,
        "lineNumber": 6,
        "type": {
          "type": "NameExpression",
          "name": "props"
        },
        "name": null,
        "errors": [
          "Missing or invalid tag name"
        ]
      },
      {
        "title": "type",
        "description": null,
        "lineNumber": 7,
        "type": {
          "type": "NameExpression",
          "name": "Boolean"
        }
      },
      {
        "title": "default",
        "description": "true",
        "lineNumber": 8
      }
    ],
    "loc": {
      "start": {
        "line": 330,
        "column": 2
      },
      "end": {
        "line": 339,
        "column": 5
      }
    },
    "context": {
      "loc": {
        "start": {
          "line": 340,
          "column": 2
        },
        "end": {
          "line": 343,
          "column": 3
        }
      },
      "file": "/Users/reddico/Documents/vue-tags-input/vue-tags-input/vue-tags-input.props.js"
    },
    "augments": [],
    "examples": [],
    "params": [],
    "properties": [],
    "returns": [],
    "sees": [],
    "throws": [],
    "todos": [],
    "type": {
      "type": "NameExpression",
      "name": "Boolean"
    },
    "name": "deleteOnBackspace",
    "memberof": "vue-tags-input.props",
    "scope": "static",
    "members": {
      "global": [],
      "inner": [],
      "instance": [],
      "events": [],
      "static": []
    },
    "path": [
      {
        "name": "deleteOnBackspace",
        "scope": "static"
      }
    ],
    "namespace": ".deleteOnBackspace"
  }
];